import { sanitizeFilename } from "./sanitizeFilename";

export const getStorageFilenameFromPath = (attachmentPath: string): string => attachmentPath.split("/").pop() ?? "";

export const buildStorageFilename = (attachmentId: string, originalName: string): string =>
    `${attachmentId}_${sanitizeFilename(originalName)}`;

export const getDisplayFilename = (attachmentId: string, attachmentPath: string): string => {
    const storageFilename = getStorageFilenameFromPath(attachmentPath);
    const prefix = `${attachmentId}_`;

    if (storageFilename.startsWith(prefix)) {
        return decodeURIComponent(storageFilename.slice(prefix.length));
    }

    return decodeURIComponent(storageFilename);
};
